import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { PersonStores, useAuthStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImpersonateButton',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();

const authStore = useAuthStore();

const toast = useToast();

const canImpersonate = computed<boolean>(() => {
  const person = profileStore.person;
  return !authStore.isImpersonating && !!person?.user?.can_login && !person?.archived_at;
});

const onImpersonate = async () => {
  await authStore.impersonate(profileStore.id as number);
  if (authStore.error) doFail(authStore.error);
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (canImpersonate.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppButton, {
          type: "secondary",
          text: "Impersonate",
          "icon-left": "fingerprint",
          onClick: onImpersonate
        })
      ]))
    : _createCommentVNode("", true)
}
}

})